<div class="settingsHeader__wrapper">
  <ng-content></ng-content>
</div>
